import * as Sentry from '@sentry/browser'
import type { Environment } from 'config/environment'

export default ({ sentryEnabled, sentryEnvironment, releaseVersion }: Environment) => {
  if (sentryEnabled) {
    Sentry.init({
      release: releaseVersion,
      environment: sentryEnvironment,
      dsn: 'https://96506a1eb3e249d99e38f71ce79323a7@o43318.ingest.sentry.io/101394',
      integrations: [Sentry.extraErrorDataIntegration({ depth: 2 })],
      ignoreErrors: [
        'ValidationError',
        'NetworkError',
        'BusinessError',
        'Non-Error promise rejection captured with value: Object Not Found Matching Id',
        'Failed to fetch',
      ],
    })
  }
}
